import { createGlobalStyle } from 'styled-components';

import './theme.scss';

/* istanbul ignore next */
export const GlobalStyle = createGlobalStyle`

`;
